// hide Shopify's stupid preview bar that never closes....
setTimeout(function () {
  $("#preview-bar-iframe").remove()
}, 3000)

// Cookie Modal
function checkCookie() {
  cookieCheck = document.cookie.match(
    /^(.*;)?\s*DBSHOPCookieAccepted\s*=\s*[^;]+(.*)?$/
  )
  if (cookieCheck) {
    $(".cookie-modal").remove()
  } else {
    $(".cookie-modal").slideDown(1000)
    setTimeout(function () {
      $(".cookie-modal").show()
    }, 1100)
  }
}

function acceptCookies() {
  $(".cookie-modal").fadeOut(220)
  setTimeout(function () {
    $(".cookie-modal").remove()
  }, 225)
  createCookie("DBSHOPCookieAccepted", "accepted")
}

function createCookie(name, value) {
  document.cookie =
    name + "=" + value + "; expires=Fri, 31 Dec 9999 23:59:59 GMT" + "; path=/"
}

$(".cookie-modal--accept").on("click", function () {
  acceptCookies()
})

$(function () {
  //checkCookie()

  if ($('input[value="autodeliver"]').is(":checked")) {
    $(".shopify-payment-button").hide()
  }
  $('input[type="radio"]').on("click", function () {
    if ($("#rc_container").is(":visible")) {
      if ($('input[value="onetime"]').is(":checked") && $("#rc_container").is(':visible')) {
        $(".shopify-payment-button").show();
      } else {
        $(".shopify-payment-button").hide();
      }
    }
  });
})

// Ajax Cart Subscription Variant hide
$(".js-drawer-open-cart").on("click", function () {
  $(".ajaxcart__product-meta").each(function () {
    if (
      this.innerText.includes("subscription_id") ||
      this.innerText.includes("shipping_interval_unit_type") ||
      this.innerText.includes("shipping_interval_frequency")
    ) {
      $(this).hide()
    }
  })
})

// Hide Buy 1 get 1 subscription
$('.variant-input input[type="radio"]').on('click', function() {
  if (this.value.toLowerCase().includes('buy') && this.value.toLowerCase().includes('get')){
    $('#rc_radio_options input')[0].click()
    $('#rc_container').hide()
  } else {
    $('#rc_container').show()
  }
})